import { Panel, PanelType } from 'office-ui-fabric-react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import React, { Component, Fragment } from 'react';
import '../../css/immocom.css';
import { DataAPIParametre } from '../../data/DataAPIParametre';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxTypeAPIParametre } from '../ComboBox/ComboBoxTypeAPIParametre';
import { EUIDialog } from '../EUI/EUIDialog';
import { EUITextField } from '../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/*
******************************************************************************************************
PROPS :
    ATTRIBUTS :
        int     idAPI                       id de l'API à laquelle sera rattaché le paramètre
        int?    idAPIParametre              id du parametre
        bool    isOpen                      détermine si panel ouvert ou non
        string  nomParametre                nom du paramètre
        bool    presenceObligatoire         détermine si balise obligatoire ou non
        int     typeValeurBalise            type du paramètre
        bool    valeurObligatoire           détermine si valeur nulle autorisée ou non
        string  libelleParametre            libellé personnalisé (celui éventuellement utilisé par les partenaires)
        string  valeurParDefaut             

    METHODES :
        void    onDismiss                   méthode appelée lorsque l'utilisateur clique sur "Annuler"
        void    onMiseAJour                 méthode appelée lorsque l'utilisateur clique sur "Valider" ou "Supprimer"
******************************************************************************************************
*/

export class FicheAPIParametre extends Component {

    static defaultProps = {
        nomParametre: "",
        presenceObligatoire: true,
        typeValeurBalise: -1,
        typeValeurBaliseStr: "",
        valeurObligatoire: true,
        libelleParametre: "",
        valeurParDefaut: "",
    };

    constructor(props) {
        super(props);
        this.state = {};
    };

    _estFicheOuverteEnModeCreation = () => {
        return !this.props.idAPIParametre;
    };

    _enregistrer = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Enregistrement du paramètre en cours..."
        });

        const { idAPI, idAPIParametre } = this.props;
        const { nomParametre, presenceObligatoire, typeValeurBalise, typeValeurBaliseStr, valeurObligatoire, libelleParametre, valeurParDefaut } = this.state;
        const parametre = { idAPI, idAPIParametre, nomParametre, presenceObligatoire, typeValeurBalise, typeValeurBaliseStr, valeurObligatoire, libelleParametre, valeurParDefaut };

        DataAPIParametre._onEnregistrementAPIParametre(parametre)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });
                    this.props.onMiseAJour();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                }
            });

    };

    _onOpen = () => {
        const { nomParametre, presenceObligatoire, typeValeurBalise, typeValeurBaliseStr, valeurObligatoire, libelleParametre, valeurParDefaut } = this.props;
        this.setState(
            {
                nomParametre, presenceObligatoire, typeValeurBalise, typeValeurBaliseStr, valeurObligatoire, libelleParametre, valeurParDefaut,
                hideMessageBarError: true,
                hideMessageBarWarning: true,
                onActiveBoutonEnregistrer: false
            },
            this._onVerificationFormulaire
        );
    };

    _onRenderFooterContent = () => {
        const { onActiveBoutonEnregistrer } = this.state;
        return <Stack horizontal gap={8}>
            <PrimaryButton onClick={this._enregistrer} disabled={!onActiveBoutonEnregistrer}>Valider</PrimaryButton>
            {/*!this._estFicheOuverteEnModeCreation() && <PrimaryButton onClick={this._toggleDialogSuppression(true)}>Supprimer</PrimaryButton>*/}
            <DefaultButton onClick={this.props.onDismiss}>Fermer</DefaultButton>
        </Stack>;
    };

    _onVerificationFormulaire = () => {
        const { nomParametre, presenceObligatoire, typeValeurBalise, typeValeurBaliseStr, valeurObligatoire, libelleParametre, valeurParDefaut } = this.state;
        const parametre = { nomParametre, presenceObligatoire, typeValeurBalise, typeValeurBaliseStr, valeurObligatoire, libelleParametre, valeurParDefaut };
        Immocom.fiche()._validationFormulaire(this, "APIParametre", parametre, this._estFicheOuverteEnModeCreation() ? "Création" : "Modification");
    };

    _toggleDialogSuppression = (isOpen) => () => {
        this.setState({ afficherDialogSuppression: isOpen });
    };

    _supprimer = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Suppression du paramètre en cours..."
        });

        const { idAPI, idAPIParametre } = this.props;
        let suppressionAPIParametre = DataAPIParametre._onSuppressionAPIParametre(idAPI, idAPIParametre);
        suppressionAPIParametre
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    this.props.onMiseAJour();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                }
            });
        this._toggleDialogSuppression(false)();

    };

    render = () => {

        const { isOpen, onDismiss } = this.props;
        const { afficherDialogSuppression, nomParametre, presenceObligatoire, typeValeurBalise, valeurObligatoire, libelleParametre, valeurParDefaut } = this.state;
        const estFicheOuverteEnModeCreation = this._estFicheOuverteEnModeCreation();

        return <Fragment>

            <Panel
                closeButtonAriaLabel="Fermer"
                headerText={`${this._estFicheOuverteEnModeCreation() ? "Création" : "Modification"} d'un paramètre d'API`}
                isOpen={isOpen}
                onDismiss={onDismiss}
                onOpen={this._onOpen}
                onRenderFooterContent={this._onRenderFooterContent}
                type={PanelType.smallFixedFar}
            >

                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                <Stack>

                    <MessageBars
                        errorMessage={this.state.errorMessage}
                        infoMessage={this.state.messageMessageBarFiltres}
                        warningMessage={this.state.warningMessage}
                        onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                        onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                    />

                    <EUITextField
                        disabled={!estFicheOuverteEnModeCreation}
                        label="Nom"
                        maxLength={MaxLengths.apiParametre.nomParametre}
                        onDelayedChange={(event, newValue) => this.setState({ nomParametre: newValue }, this._onVerificationFormulaire)}
                        placeholder="Nom"
                        required
                        value={nomParametre}
                    />

                    <ComboBoxTypeAPIParametre
                        disabled={!estFicheOuverteEnModeCreation || !nomParametre}
                        onChange={(event, option) => this.setState({ typeValeurBalise: option.key, typeValeurBaliseStr: option.text }, this._onVerificationFormulaire)}
                        required
                        selectedKey={typeValeurBalise}
                    />

                    <Toggle
                        checked={presenceObligatoire}
                        disabled={!nomParametre}
                        label="Balise obligatoire ?"
                        onText="Oui"
                        offText="Non"
                        onChange={(e, isChecked) => this.setState({ presenceObligatoire: isChecked }, this._onVerificationFormulaire)}
                    />

                    <Toggle
                        checked={valeurObligatoire}
                        disabled={!nomParametre}
                        label="Valeur obligatoire ?"
                        onText="Oui"
                        offText="Non"
                        onChange={(e, isChecked) => this.setState({ valeurObligatoire: isChecked }, this._onVerificationFormulaire)}
                    />

                    <EUITextField
                        label="Libellé personnalisé"
                        maxLength={MaxLengths.apiParametre.libelleParametre}
                        onDelayedChange={(event, newValue) => this.setState({ libelleParametre: newValue }, this._onVerificationFormulaire)}
                        placeholder="Libellé personnalisé"
                        value={libelleParametre}
                    />

                    <EUITextField
                        label="Valeur par défaut"
                        maxLength={MaxLengths.apiParametre.valeurParDefaut}
                        onDelayedChange={(event, newValue) => this.setState({ valeurParDefaut: newValue }, this._onVerificationFormulaire)}
                        placeholder="Valeur par défaut"
                        value={valeurParDefaut}
                    />

                </Stack>

                <EUIDialog
                    buttons={[
                        <PrimaryButton key="delete" onClick={this._supprimer} text="Supprimer" />,
                        <DefaultButton key="cancel" onClick={this._toggleDialogSuppression(false)} text="Annuler" />
                    ]}
                    isOpen={afficherDialogSuppression}
                    message="Confirmez-vous la suppression de ce paramètre ?"
                    onDismiss={this._toggleDialogSuppression(false)}
                    titre="Suppression d'un paramètre"
                />

            </Panel>

        </Fragment>;

    };

};